var Vendd = (function (Vendd) {
    'use strict';

    Vendd.LuckyDraw = (function (LuckyDraw) {

        LuckyDraw.Messages = (function (Messages) {

            Messages.Draw = function (userEmail, userIdentifier) {
                var data = {
                    email: userEmail,
                    userGuid: userIdentifier
                };

                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.LuckyDraw.Messages.Draw', data);
            };
            Messages.Draw.className = 'Vendd.LuckyDraw.Messages.Draw';

            Messages.DrawSuccess = function (response) {

                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.LuckyDraw.Messages.DrawSuccess', response);
            };
            Messages.DrawSuccess.className = 'Vendd.LuckyDraw.Messages.DrawSuccess';

            Messages.DrawFailure = function (response) {

                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.LuckyDraw.Messages.DrawFailure', response);
            };
            Messages.DrawFailure.className = 'Vendd.LuckyDraw.Messages.DrawFailure';

            // GetSegmentsAndCurrentBalance
            Messages.GetSegmentsAndCurrentBalance = function () {

                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.LuckyDraw.Messages.GetSegmentsAndCurrentBalance');

            };
            Messages.GetSegmentsAndCurrentBalance.className = 'Vendd.LuckyDraw.Messages.GetSegmentsAndCurrentBalance';

            Messages.GetSegmentsAndCurrentBalanceSuccess = function (response) {

                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.LuckyDraw.Messages.GetSegmentsAndCurrentBalanceSuccess', response);
            };
            Messages.GetSegmentsAndCurrentBalanceSuccess.className = 'Vendd.LuckyDraw.Messages.GetSegmentsAndCurrentBalanceSuccess';

            Messages.GetSegmentsAndCurrentBalanceFailure = function (response) {

                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.LuckyDraw.Messages.GetSegmentsAndCurrentBalanceFailure', response);
            };
            Messages.GetSegmentsAndCurrentBalanceFailure.className = 'Vendd.LuckyDraw.Messages.GetSegmentsAndCurrentBalanceFailure';

            return Messages;

        })(LuckyDraw.Messages || {});

        return LuckyDraw;

    })(Vendd.LuckyDraw || {});

    return Vendd;

})(Vendd || {});